import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5754fec3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center gap-[30px]" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "export-title" }, "Export", -1))

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton, IncrediItem, IncrediList, IncrediMenu } from 'incredi-ui';
import { ref } from 'vue';
import { ExportOptions } from '@/components/common/exportCsv/exportCsv.helpers';
import COLORS from '@/design-system/colors.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'exportCsv',
  props: {
    modelValue: null,
    disabled: { type: Boolean },
    options: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:model-value', value: ExportOptions): void }), expose: any, slots: any, attrs: any }) {



const menuOpen = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IncrediMenu), {
          direction: "bottom-sticky-right",
          "offset-y": 4,
          "offset-x": 0,
          "model-value": __props.disabled ? false : menuOpen.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = (e) => menuOpen.value = e)
        }, {
          content: _withCtx(() => [
            _createVNode(IbxScopedCss, {
              ref: "menuRef",
              style: {"width":"200px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IncrediList), null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
                      return (_openBlock(), _createBlock(_unref(IncrediItem), {
                        key: index,
                        class: "cursor-pointer",
                        selected: option === __props.modelValue,
                        onClick: (e) => {emit('update:model-value', option as ExportOptions); menuOpen.value = false;}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(option), 1)
                        ]),
                        _: 2
                      }, 1032, ["selected", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(IncrediButton), {
              design: "ghost-neon",
              size: "small",
              selected: menuOpen.value || !!__props.modelValue,
              disabled: __props.disabled
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (__props.disabled)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle({ 'border-color': _unref(COLORS)['Text/text_low'], 'border-bottom': '2px solid transparent' }),
                        class: "infinite-spinner-animation rounded-[50%] border-2 border-solid mr-[8px] !w-[16px] !h-[16px]"
                      }, null, 4))
                    : (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        class: _normalizeClass([__props.disabled ? 'text-Text/text_low' : 'text-Text/text_high', "text-Text/text_high uil uil-import !text-[20px]"])
                      }, null, 2)),
                  _hoisted_3
                ])
              ]),
              _: 1
            }, 8, ["selected", "disabled"])
          ]),
          _: 1
        }, 8, ["model-value"])
      ])
    ]),
    _: 1
  }))
}
}

})